const BUTTON_CODES = [13, 32];

const handleEnterPress = (e, cb) => {
  // eslint-disable-next-line no-unused-expressions
  BUTTON_CODES.includes(e.keyCode) && cb();
};

export { handleEnterPress };
